import { render } from "./FeaturesSection.vue?vue&type=template&id=62048150&scoped=true"
import script from "./FeaturesSection.vue?vue&type=script&lang=js"
export * from "./FeaturesSection.vue?vue&type=script&lang=js"

import "./FeaturesSection.vue?vue&type=style&index=0&id=62048150&lang=scss&scoped=true"

import exportComponent from "/Users/suzukitatsuya/kaon_r-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62048150"]])

export default __exports__